<template>

    <article id="signup">

        <h1>Opret ny bruger</h1>

        <form @submit.prevent="onSubmit">

            <fieldset>
                <label for="email">
                    Email
                    <form-error :content="errors.email" />
                    <form-error :content="errors.username" />
                </label>
                <input type="email" id="email" v-model="email" required ref="emailinput">
            </fieldset>

            <fieldset>
                <label for="firstname">
                    Fornavn
                    <form-error :content="errors.first_name" />
                </label>
                <input type="text" id="firstname" v-model="first_name" required>
            </fieldset>

            <fieldset>
                <label for="lastname">
                    Efternavn(e)
                    <form-error :content="errors.last_name" />
                </label>
                <input type="text" id="lastname" v-model="last_name" required>
            </fieldset>

            <address-autocomplete v-on:address-pick="setAddress" :errors="address_errors" />

            <fieldset>
                <label for="phone">
                    Telefonnummer
                    <form-error :content="errors.phone" />
                </label>
                <input type="tel" id="phone" v-model="phone" required>
            </fieldset>

            <fieldset>
                <label for="password">
                    Angiv et kodeord
                    <form-error :content="errors.password" />
                    <form-error :content="errors.password2" />
                </label>
                <input type="password" id="password" v-model="password" required minlength="8">
                <p class="formhelp">Kodeordet skal være mindst 8 tegn langt og indholde både tal og bogstaver</p>
            </fieldset>
            
            <fieldset>
                <template v-if="show_terms">
                    <terms />
                </template>
                <p style="display: flex; align-items: flex-start;">
                    <input type="checkbox" id="accept-terms" v-model="terms" required style="margin: 0 .5rem 0 0;">
                    <label for="accept-terms">Jeg giver samtykke til brug af mine personlige oplysninger</label>
                </p>
                <p v-if="!show_terms">
                    <button type="button" class="btn-link" @click="show_terms = !show_terms">Du bør læse her, hvad du giver samtykke til.</button>
                </p>
            </fieldset>
                
            <fieldset>
                <input type="submit" value="Opret">
                <input type="reset" value="Annullér">
            </fieldset>

        </form>

    </article>

</template>

<script>

    import axios from '../../utils/Http.js'
    import notify from '../../utils/notify/Notify.js'
    import formError from '../forms/Error.vue'
    import terms from '../../views/Terms.vue'
    import addressAutocomplete from '../forms/AddressAutocomplete.vue'

    export default {

        components: {
            formError,
            terms,
            addressAutocomplete
        },
        data () {
            return {
                password: '',
                email: '',
                first_name: '',
                last_name: '',
                street: '',
                number: 0,
                floor: '',
                door: '',
                zipcode: '',
                town: '',
                phone: '',
                terms: false,
                errors: {},
                address_errors: null,
                show_terms: false
            }
        },
        methods: {
            onSubmit () {

                this.errors = {}
                this.address_errors = null
                if (this.zipcode === '' || this.town === '' || this.number === '') {
                    this.address_errors = ['Der er noget galt med adressen', 'Prøv at vælge én af de adresser, som bliver foreslået.']
                    return
                }

                axios({
                    method: 'post',
                    url: '/auth/register/',
                    data: {
                        password1: this.password,
                        password2: this.password,
                        email: this.email,
                        first_name: this.first_name,
                        last_name: this.last_name,
                        phone: this.phone,
                        street: this.street,
                        number: this.number,
                        floor: this.floor,
                        door: this.door,
                        zipcode: this.zipcode,
                        town: this.town
                    }
                })
                .then(res => {
                    notify('Du har oprettet en ny bruger.', 'success')
                    this.$router.push('/signup-success')
                })
                .catch(err => {
                    this.errors = this.switchErrorMsg(err.response.data)
                    if (this.errors.street || this.errors.number || this.errors.zipcode || this.errors.town) {
                        this.address_errors = ['Der er noget galt med adressen', 'Prøv at vælge én af de adresser, som bliver foreslået.']
                    }
                    notify('Du kunne ikke oprettes som bruger', 'error')
                })

            },
            setAddress: function(val) {
                this.street = val.adresse.vejnavn
                this.number = val.adresse.husnr
                this.floor = val.adresse.etage
                this.door = val.adresse['dør']
                this.zipcode = val.adresse.postnr
                this.town = val.adresse.postnrnavn
            },
            switchErrorMsg: function(errors){
                if (typeof errors.username !== 'undefined') {
                    var original_msg = "En bruger med dette brugernavn findes allerede.";
                    var index = errors.username.indexOf(original_msg);
                    if (index > -1) {
                        errors.username.splice(index, 1);
                        if (errors.username.length === 0) {
                            this.$delete(errors, 'username')
                        }
                        if (typeof errors.email === 'undefined') {
                            errors.email = [];
                        }
                        var new_msg = "Den angivne e-mail er allerede i brug.";
                        errors.email.push(new_msg);
                    }
                }
                return errors

            }
        },
        mounted: function() {
            this.$refs.emailinput.focus()
        }

    }
</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    #signup {
        padding: 1rem;

        .field-zip-city {
            display: flex; 
            flex-flow: row nowrap;

            fieldset {
                margin: 0;
            }
            fieldset:nth-child(1) {
                width: 6rem; margin-right: 1rem;
                flex-grow: 0;
            }
            fieldset:nth-child(2) {
                flex-grow: 1;
            }
        }
        #accept-terms {
            flex-grow: 0;
        }
        .form-error + input {
            border-color: $danger;
        }
        #terms {
            margin: 0 0 2rem;
        }
    }

</style>